import { Layers } from "appworks/graphics/layers/layers";
import { SettingsMenuControl } from "appworks/ui/controls/standard/menu/settings-menu-control";
import { LayerNames } from "game-layers";
import { ControlFactory } from "../control-factory";
import { gameiomModel } from "gameiom/model/gameiom-model";

export class SettingsMenuControlFactory implements ControlFactory {
    protected templateLayer: Layers;

    /**
     * Checks for buttons unique to the MenusContent layer.
     *
     * @param {Layers} layer - The layer to filter.
     * @returns {boolean} - True if the layer has the necessary buttons, false otherwise.
     */
    public filter(layer: Layers) {
        return gameiomModel.shouldDisplaySettingsButton() && layer.getFlexiButton("ags_home") != null && layer.getFlexiButton("help") != null;
    }

    /**
     * Builds a settings menu control based on the given layer.
     *
     * @param {Layers} _ - Discard/unused.
     * @returns {SettingsMenuControl[]} - An array of SettingsMenuControl objects built from the given layer.
     */
    public build(_: Layers) {
        this.setTemplateLayer();

        return [
            new SettingsMenuControl(
                this.templateLayer.getButton("generic_button"),
                this.templateLayer.getSprite("settings_menu_background")
            )
        ];
    }

    protected setTemplateLayer() {
        if (this.templateLayer) {
            return;
        }

        this.templateLayer = Layers.get(LayerNames.SettingsMenuTemplate);
        this.templateLayer.setScene("settings").execute();
        this.templateLayer.hide();
    }
}